<template>
  <div
    class="evaluation-evidence"
    :class="{open:isOpen}"
    v-if="item"
  >
    <header>
      <h4>Adjuntar evidencia</h4>
      <h5>{{ item.name }}</h5>
      <p>Adjunte evidencia en la sección o la pregunta</p>
      <button
        class="button-close"
        @click="close">
        <i class="icon-close"/>
      </button>
    </header>
    <main>
      <el-upload
        ref="fileUploader"
        class="upload-demo"
        :action="uploadURL"
        :headers="headers"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-remove="beforeRemove"
        multiple
        name="path"
        :file-list="filesList">
        <el-button
          size="small"
          type="primary">Seleccionar archivos
        </el-button>
      </el-upload>
    </main>
  </div>
</template>

<script>
import AuthService from '@/services/auth.service'
import http from '@/services/http.service'

/**
 * 'EvaluationEvidence' Component
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  name: 'EvaluationEvidence',
  props: {
    item: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      uploadURL: process.env.API_URL + 'upload-file',
      isOpen: false,
      filesList: []
    }
  },
  computed: {
    headers () {
      return {
        authorization: AuthService.token()
      }
    }
  },
  inject: ['evaluationId'],
  mounted () {
    console.log('evalId', this.evaluationId)
  },
  methods: {
    handleExceed (e) {
      console.log('Handle exceed', e)
    },
    beforeRemove (e) {
      console.log('Before remove', e)
    },
    handleRemove (e) {
      console.log('Handle remove', e)
    },
    handlePreview (e) {
      console.log('Handle preview', e)
    },
    handleSuccess (e, file, fileList) {
      http
        .post('evidences', {
          name: file.name,
          path: e.path,
          evaluationId: this.evaluationId
        })
        .then(response => {
          this.checkItemEvaluationsExits()
          this.item.evidence.push(response.data)
        })
    },
    open () {
      this.checkItemEvaluationsExits()
      if (this.item) {
        this.$refs.fileUploader.clearFiles()
      }
      this.isOpen = true
    },
    close () {
      if (this.item) {
        this.$refs.fileUploader.clearFiles()
      }
      this.isOpen = false
    },
    checkItemEvaluationsExits () {
      if (this.item && !this.item.evidence) {
        this.$set(this.item, 'evidence', [])
      }
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.evaluation-evidence {
  background-color: #fff;
  box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: -100vh;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  z-index: 1002;
  &.open {
    bottom: 0;
    opacity: 1;
  }
  header {
    padding: 20px;
    h4 {
      margin: 0;
      @include font-primary(14px, bold);
    }
    .button-close {
      position: absolute;
      height: 40px;
      width: 40px;
      background-color: #fff;
      border: none;
      top: 0;
      right: 0;
      font-size: 14px;
    }
  }
  main {
    padding: 0 40px 40px 40px;
    .controls {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-evidence.vue